/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';

// @ts-ignore
import {Helmet} from "react-helmet";
// @ts-ignore
import {GetLocalText,GetLocalizedText,GetLocalizedPrice,StripHtml,CapitalizeFirstLetter,GenerateProductAssetUrl} from "./../../themes/kent/utilities/functions";
// @ts-ignore
import {ModelYear, GeneralAssetUrl,SimpleProductCategories, SimpleProductSubcategories, HeaderHeight, MobileHeaderHeight} from "./../../themes/kent/utilities/constants";
import ImageScroller from "./image-scroller";
import Description from "./description";
import Thumbnails from "./thumbnails";
import DeepLinks from "./deeplinks";
import Sizes from "./sizes";
import ProductLinks from "./links";
import ZoomableProductImage from "./zoomable-product-image";
import TechFeatures from "./tech-features";
import FatSacFittings from "./fatsac-fittings";
import Disclaimers from "./disclaimers";
//@ts-ignore
import {FindFromParse} from './../../themes/kent/utilities/parse';

interface IState {
  product:any;
  slug:string;
  name:string;
  description:string;
  parentProduct?:any;
  callouts?:any;
}

interface IProps {
  product?: any;
  localizedContent?:any;
  parentProduct?:any;
  year?:any;
}

/**
 *
 * HosportsMain component
 * @extends {React.Component<IProps,IState>}
 */

class HosportsMain extends React.Component<IProps,IState> {
  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {
      product:null,
      slug:'',
      name:'',
      description:''
    };
  }
  componentDidMount = () =>{
    this.fillCallouts();
  }
  fillCallouts = async() =>{
    let results:any = await FindFromParse("ProductCallouts",[{'method':'limit','value':5000}]);
    if(this.props.product.attributes.productCallouts){
      let callouts:any = results.filter((callout:any) => this.props.product.attributes.productCallouts.indexOf(callout.id) != -1);
      this.setState({
        callouts:callouts
      })
    }
  }
  public render(): JSX.Element {
    const {product,year} = this.props;
    let prodAssetUrl:string = GenerateProductAssetUrl(year);
    if(!product) return <span />
    let desktopProdHeight:any ="auto";
    if(window.outerWidth < 800){
      desktopProdHeight = "auto";
    }
    let simpleProduct:any = false;
    if(SimpleProductCategories.indexOf(product.attributes.category) != -1 || SimpleProductSubcategories.indexOf(product.attributes.subcategory) != -1){
      if(product.attributes.slug != "waterski-accessories-syndicate-ponchowel"){
          simpleProduct=true
      }
    }
    if(product.attributes.slug == "waterski-boots-syndicate-hardshell-liner" || product.attributes.slug == "isup-tool-less-fin"){
        simpleProduct=true
    }
    let calloutImage:any = false;
    if(product.attributes.isNew){
      calloutImage = GeneralAssetUrl+"callout-new.png";
    }
    if(product.attributes.isEco){
      calloutImage = GeneralAssetUrl+"callout-eco.png";
    }
    if(product.attributes.isSoftshell){
      calloutImage = GeneralAssetUrl+"callout-softshell.png";
    }
    let brand = CapitalizeFirstLetter(product.attributes.brand);
    return (
      <div className="product-main-section row primary-background" style={{height:desktopProdHeight}}>
        <Helmet>
          <title>{brand+' '+ year+' '+this.props.localizedContent.title}</title>
          <meta name="description" content={StripHtml(this.props.localizedContent.description)} />
            <script type="application/ld+json">{`
              {
                "@context": "http://schema.org/",
                "@type": "Product",
                "name": "`+brand+` `+year+` `+this.props.localizedContent.title+`",
                "image": [
                  "`+prodAssetUrl+product.attributes.slug+`1.jpg`+`",
                  "`+prodAssetUrl+product.attributes.slug+`2.jpg`+`"
                 ],
                "description": "`+StripHtml(this.props.localizedContent.description)+`",
                "brand": {
                  "@type": "Thing",
                  "name": "Hyperlite"
                },
                "offers": {
                  "@type": "Offer",
                  "priceCurrency": "USD",
                  "price": "`+product.attributes.price+`",
                  "itemCondition": "http://schema.org/NewCondition",
                  "availability": "http://schema.org/InStock",
                  "seller": {
                    "@type": "Organization",
                    "name": "`+brand+`"
                  }
                }
              }
            `}</script>
          </Helmet>
          <div className="small-12 medium-7 large-7 product-image-container">
            <div className="product-tile-callout-column">
              {calloutImage && <img className="callout-image" src={calloutImage} />}
              {this.state.callouts && this.state.callouts.map((callout:any) =>{
                let image:any = null;
                if(callout.attributes.image){
                  image = callout.attributes.image.url();
                }
                return(<img className="product-tile-callout" src={image} />)
              })}
            </div>
            <div className="show-for-small full-width">
              <ImageScroller year={year} product={product} fullWidth force />
            </div>
            <div className="product-image hide-for-small full-width">
              <ZoomableProductImage
                year={year}
                image={product.attributes.slug+'1_1000.png'}
                product={product}
              />
            </div>
          </div>
          <div className="small-12 medium-5 large-5 flex secondary-background">
            <div className="small-padding full-width center-position" style={{maxWidth:"700px"}}>

              {product.attributes.partNumber &&
                <h6 className="subheading">
                  {product.attributes.altPartNumbers ? 'Part Numbers: ' : 'Part Number: '}
                  {product.attributes.partNumber}
                  {product.attributes.altPartNumbers ? ', ' : ''}
                  {product.attributes.altPartNumbers && product.attributes.altPartNumbers.map((data:any, index:any) =>{
                    if(index != product.attributes.altPartNumbers.length -1){
                      return(product.attributes.altPartNumbers[index]+', ')
                    } else{
                      return(product.attributes.altPartNumbers[index])
                    }
                  })}
                </h6>
              }

              {this.props.localizedContent && <h6 className="text-color-secondary">{this.props.localizedContent.tagline}</h6>}
              {this.props.localizedContent && <h3 className="product-detail-title text-color-primary" style={{marginTop:"10px",marginBottom:"10px"}}>{this.props.localizedContent.title}</h3>}
              {this.props.localizedContent && <h4 className="text-color-secondary" style={{marginTop:"10px", marginBottom:"10px"}}>{this.props.localizedContent.price}</h4>}
              {product.attributes.subcategory == "g7lQZjE06q" &&
                <p className="subheading"><i>{'Custom colors available for an extra fee'}</i></p>
              }
              {product.attributes.build && <p className="subheading" style={{marginTop:'10px'}}><i>{product.attributes.build}</i></p>}
              {product.attributes.sizeDescription && <p className="subheading" style={{marginTop:'10px'}}><i>{product.attributes.sizeDescription}</i></p>}

              <div className="hide-for-small">
                <Thumbnails year={year} product={product} />
              </div>
              <div className="secondary-background tiny-top-margin tiny-bottom-margin" style={{height:'1px'}}></div>
              <Sizes parentProduct={this.props.parentProduct} product={product} />
              <ProductLinks parentProduct={this.props.parentProduct} product={product} />
              <Disclaimers parentProduct={this.props.parentProduct} product={product} />
              <Description
                parentProduct={this.props.parentProduct}
                product={product}
              />
              {simpleProduct && <TechFeatures year={year} simpleProduct={simpleProduct} product={product} parentProduct={this.props.parentProduct} /> }
              <FatSacFittings product={this.state.product} />
              <DeepLinks product={product} />
              {product.attributes.slug == "ballast-m1090" &&
                <div className="small-full-width white tiny-top-margin" style={{backgroundColor:'#999', padding:20, display:'inline-block'}}>
                  {'Temporarily Unavailable'}
                </div>
              }
            </div>
          </div>
        </div>
    );
  }
}

export default HosportsMain;
